import Header from '../../blocks/header/scripts'
import {Hero , SliderHero} from '../../blocks/hero/scripts'
import TitleText from '../../blocks/title-text/scripts'
import SliderImg from '../../blocks/slider-img/scripts'
import ImgAccordeon from '../../blocks/img-accordeon/scripts'
import ProductGrid from '../../blocks/product-grid/scripts'
import DoubleImg from '../../blocks/double-img/scripts'
import TripleImg from '../../blocks/triple-img/scripts'
import Testimonials from '../../blocks/testimonials/scripts'
import Blog from '../../blocks/blog/scripts'
import ArticleBlog from '../../blocks/article-blog/scripts'
import Contact from '../../blocks/contact/scripts'
import Maps from '../../blocks/maps/scripts'
import initReveal from './reveal'
import BrandList from '../../blocks/brand-list/scripts'
import HomePicto from '../../blocks/home-picto/scripts'

let headerInstance = null

function initHeader() {
  const el = document.querySelector('.header')
  if (!el) return
  if (!headerInstance) {
    headerInstance = new Header(el)
  } else {
    headerInstance.initColorPrimary()
  }
}

document.addEventListener('DOMContentLoaded', () => {

  initHeader()

  document.querySelectorAll('.hero').forEach(el => new Hero(el))
  document.querySelectorAll('.hero').forEach(el => new SliderHero(el))

  initReveal()

  document.querySelectorAll('.title-text').forEach(el => new TitleText(el))

  document.querySelectorAll('.slider-img').forEach(el => new SliderImg(el))
  
  document.querySelectorAll('.img-accordeon').forEach(el => new ImgAccordeon(el))

  document.querySelectorAll('.product-grid').forEach(el => new ProductGrid(el))
  
  document.querySelectorAll('.double-img').forEach(el => new DoubleImg(el))
  
  document.querySelectorAll('.triple-img').forEach(el => new TripleImg(el))
  
  document.querySelectorAll('.testimonials').forEach(el => new Testimonials(el))
  
  document.querySelectorAll('.blog--masonry').forEach(el => new Blog(el))
  
  document.querySelectorAll('.article-blog').forEach(el => new ArticleBlog(el))
  
  document.querySelectorAll('.contact').forEach(el => new Contact(el))
  
  document.querySelectorAll('.maps').forEach(el => new Maps(el))

  document.querySelectorAll('.brand-list').forEach(el => new BrandList(el))

  document.querySelectorAll('.home-picto').forEach(el => new HomePicto(el))

});